import React from 'react'
import {BooleanInput, TextInput, Edit, SimpleForm, TextField,} from 'react-admin'
import {required} from '../../validators'
import EditActions from '../../custom/common/EditActions'
import EditToolbar from '../../custom/common/EditToolbar'

export default (props) => (
  <Edit {...props} actions={<EditActions/>}>
    <SimpleForm toolbar={<EditToolbar/>}>
      <TextInput disabled source='id'/>
      <TextField source="name"/>
      <BooleanInput source="isNoti" validate={required}/>
    </SimpleForm>
  </Edit>
)
